import AxiosClient from "../../services/axios.services";

class AuroraDivisionServices {
  getAuroraDivisions = (params) =>
    AxiosClient.get( "/api/app/Funcional_Division_Aurora/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveAuroraDivision = (data) =>
    AxiosClient.post( "/api/app/Funcional_Division_Aurora/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editAuroraDivision = (id, data) =>
    AxiosClient.put(
   
        `/api/app/Funcional_Division_Aurora/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteAuroraDivision = (id) =>
    AxiosClient.delete(    
        `/api/app/Funcional_Division_Aurora/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new AuroraDivisionServices();
